import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "basiclayout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import GlobalHeader from "@/components/GlobalHeader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_icon_github = _resolveComponent("icon-github")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icon_copyright = _resolveComponent("icon-copyright")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(GlobalHeader)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_footer, { class: "footer" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tooltip, { content: "查看本站技术及源码，欢迎 star" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_link, {
                  href: "https://github.com/1ranxu/luooj-backend-microservice",
                  target: "_blank",
                  style: {"color":"black","text-decoration-color":"white","background-color":"rgb(255,255,255,0)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_github)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_component_icon_copyright),
            _createTextVNode(" " + _toDisplayString(new Date().getFullYear()) + "落樱工作室出品 | ", 1),
            _createVNode(_component_a_link, {
              href: "https://beian.miit.gov.cn/",
              target: "_blank",
              style: {"color":"black","background-color":"rgb(255,255,255,0)"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 渝ICP备2024021408号-2 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})